__turbopack_context__.v({
  "aliasLine": "drugs-page-module__HT0-ga__aliasLine",
  "blockHeading": "drugs-page-module__HT0-ga__blockHeading",
  "canvas": "drugs-page-module__HT0-ga__canvas",
  "canvasMobile": "drugs-page-module__HT0-ga__canvasMobile",
  "canvasStack": "drugs-page-module__HT0-ga__canvasStack",
  "card": "drugs-page-module__HT0-ga__card",
  "cardFoot": "drugs-page-module__HT0-ga__cardFoot",
  "cardSelected": "drugs-page-module__HT0-ga__cardSelected",
  "cardTop": "drugs-page-module__HT0-ga__cardTop",
  "chip": "drugs-page-module__HT0-ga__chip",
  "chipEmpty": "drugs-page-module__HT0-ga__chipEmpty",
  "chipRow": "drugs-page-module__HT0-ga__chipRow",
  "classLine": "drugs-page-module__HT0-ga__classLine",
  "controlNote": "drugs-page-module__HT0-ga__controlNote",
  "drugsPulse": "drugs-page-module__HT0-ga__drugsPulse",
  "emptyBody": "drugs-page-module__HT0-ga__emptyBody",
  "emptyCta": "drugs-page-module__HT0-ga__emptyCta",
  "emptyState": "drugs-page-module__HT0-ga__emptyState",
  "emptyTitle": "drugs-page-module__HT0-ga__emptyTitle",
  "exploreBtn": "drugs-page-module__HT0-ga__exploreBtn",
  "fetchError": "drugs-page-module__HT0-ga__fetchError",
  "fetchNote": "drugs-page-module__HT0-ga__fetchNote",
  "filterGroup": "drugs-page-module__HT0-ga__filterGroup",
  "filterRow": "drugs-page-module__HT0-ga__filterRow",
  "footAction": "drugs-page-module__HT0-ga__footAction",
  "footCaption": "drugs-page-module__HT0-ga__footCaption",
  "footNote": "drugs-page-module__HT0-ga__footNote",
  "grid": "drugs-page-module__HT0-ga__grid",
  "indicationsBlock": "drugs-page-module__HT0-ga__indicationsBlock",
  "indicationsLink": "drugs-page-module__HT0-ga__indicationsLink",
  "legend": "drugs-page-module__HT0-ga__legend",
  "legendItem": "drugs-page-module__HT0-ga__legendItem",
  "legendSwatch": "drugs-page-module__HT0-ga__legendSwatch",
  "list": "drugs-page-module__HT0-ga__list",
  "name": "drugs-page-module__HT0-ga__name",
  "nameBlock": "drugs-page-module__HT0-ga__nameBlock",
  "orb": "drugs-page-module__HT0-ga__orb",
  "page": "drugs-page-module__HT0-ga__page",
  "phaseBar": "drugs-page-module__HT0-ga__phaseBar",
  "phaseBarEmpty": "drugs-page-module__HT0-ga__phaseBarEmpty",
  "phaseBlock": "drugs-page-module__HT0-ga__phaseBlock",
  "phaseFrame": "drugs-page-module__HT0-ga__phaseFrame",
  "phaseHead": "drugs-page-module__HT0-ga__phaseHead",
  "phaseSeg": "drugs-page-module__HT0-ga__phaseSeg",
  "phaseSegOther": "drugs-page-module__HT0-ga__phaseSegOther",
  "phaseSegP1": "drugs-page-module__HT0-ga__phaseSegP1",
  "phaseSegP2": "drugs-page-module__HT0-ga__phaseSegP2",
  "phaseSegP3": "drugs-page-module__HT0-ga__phaseSegP3",
  "phaseSegP4": "drugs-page-module__HT0-ga__phaseSegP4",
  "phaseTip": "drugs-page-module__HT0-ga__phaseTip",
  "phaseTipArrow": "drugs-page-module__HT0-ga__phaseTipArrow",
  "phaseTipDarkText": "drugs-page-module__HT0-ga__phaseTipDarkText",
  "row": "drugs-page-module__HT0-ga__row",
  "rowClass": "drugs-page-module__HT0-ga__rowClass",
  "rowMain": "drugs-page-module__HT0-ga__rowMain",
  "rowName": "drugs-page-module__HT0-ga__rowName",
  "rowOrb": "drugs-page-module__HT0-ga__rowOrb",
  "rowStat": "drugs-page-module__HT0-ga__rowStat",
  "rowStatNone": "drugs-page-module__HT0-ga__rowStatNone",
  "rowSub": "drugs-page-module__HT0-ga__rowSub",
  "scopeNote": "drugs-page-module__HT0-ga__scopeNote",
  "searchClear": "drugs-page-module__HT0-ga__searchClear",
  "searchField": "drugs-page-module__HT0-ga__searchField",
  "searchIcon": "drugs-page-module__HT0-ga__searchIcon",
  "searchInput": "drugs-page-module__HT0-ga__searchInput",
  "searchLabel": "drugs-page-module__HT0-ga__searchLabel",
  "searchRow": "drugs-page-module__HT0-ga__searchRow",
  "skeleton": "drugs-page-module__HT0-ga__skeleton",
  "skeletonBar": "drugs-page-module__HT0-ga__skeletonBar",
  "skeletonOrb": "drugs-page-module__HT0-ga__skeletonOrb",
  "stat": "drugs-page-module__HT0-ga__stat",
  "statLabel": "drugs-page-module__HT0-ga__statLabel",
  "statValue": "drugs-page-module__HT0-ga__statValue",
  "statValueNone": "drugs-page-module__HT0-ga__statValueNone",
  "stats": "drugs-page-module__HT0-ga__stats",
  "trackingPill": "drugs-page-module__HT0-ga__trackingPill",
  "viewBtn": "drugs-page-module__HT0-ga__viewBtn",
  "viewBtnOn": "drugs-page-module__HT0-ga__viewBtnOn",
  "viewGroup": "drugs-page-module__HT0-ga__viewGroup",
});
